import React, { useState, useEffect } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import {
  ClassicEditor,
  Essentials,
  Paragraph,
  Bold,
  Italic,
  Heading,
  Link,
  List,
  BlockQuote,
  Table,
  MediaEmbed,
  PasteFromOffice,
  Font,
  Alignment,
} from "ckeditor5";
const AddFAQModal = ({ isOpen, onClose, onSubmit, editData }) => {
  console.log("faq edit data", editData);
  // Form state
  const [formData, setFormData] = useState({
    question: "",
    answer: "",
  });

  // Error state
  const [errors, setErrors] = useState({
    question: "",
    answer: "",
  });

  // Reset form when modal opens
  useEffect(() => {
    if (isOpen) {
      if (editData) {
        setFormData({
          question: editData?.questtion || "",
          answer: editData?.answer || "",
          status: editData?.status || "",
        });
      } else {
        setFormData({ question: "", answer: "" });
      }
      setErrors({ question: "", answer: "" });
    }
  }, [isOpen, editData]);

  // Handle input changes
  const handleInputChangeQuestion = (value, type) => {
    // const { name, value } = value;
    if (type === "question") {
      setFormData((prev) => ({
        ...prev,
        question: value,
      }));
    }
    if (type === "answer") {
      setFormData((prev) => ({
        ...prev,
        answer: value,
      }));
    }
    // if (errors[name]) {
    //   setErrors((prev) => ({
    //     ...prev,
    //     [name]: "",
    //   }));
    // }
  };

  // Form validation
  const validateForm = () => {
    let isValid = true;
    const newErrors = {};

    if (!formData.question.trim()) {
      newErrors.question = "Question is required";
      isValid = false;
    }

    if (!formData.answer.trim()) {
      newErrors.answer = "Answer is required";
      isValid = false;
    } else if (formData.answer.length > 30000) {
      newErrors.answer = "Answer cannot exceed 500 characters";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  // Handle form submission
  const handleSubmit = () => {
    if (validateForm()) {
      onSubmit?.(formData);
      onClose();
    }
  };

  // useEffect(() => {
  //   if (editData) {
  //     setFormData({
  //       question: editData?.questtion ? editData?.questtion : "",
  //       answer: editData?.answer ? editData?.answer : "",
  //       status: editData?.status ? editData?.status : "",
  //     });
  //   }
  // }, [editData]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="flex min-h-full items-center justify-center p-4">
        <div
          className="relative w-full max-w-2xl transform overflow-hidden rounded-lg bg-white p-6 shadow-xl transition-all"
          onClick={(e) => e.stopPropagation()}
        >
          {/* Close button */}
          <button
            onClick={onClose}
            className="absolute right-4 top-4 text-gray-400 hover:text-gray-500"
          >
            {/* <X className="h-5 w-5" /> */}
          </button>

          <h2 className="text-xl font-medium mb-6">
            {editData ? "Edit FAQ" : "Add FAQ"}
          </h2>

          <div className="space-y-4">
            {/* Question Field */}
            <div>
              <label className="block text-sm font-medium mb-1">Question</label>
              {/* <input
                type="text"
                name="question"
                value={formData.question}
                onChange={handleInputChange}
                placeholder="type here"
                className={`w-full p-2 border rounded-md ${
                  errors.question ? "border-red-500" : ""
                }`}
              /> */}
              <div
                style={{
                  // border: "1px solid #ccc",
                  padding: "10px",
                  marginTop: "10px",
                  lineHeight: "1.6",
                }}
              >
                <style>
                  {`
                          ul, ol {
                            margin: 0;
                            padding-left: 20px;
                            list-style: disc; /* Ensure bullet points */
                          }
                          ol {
                            list-style: decimal; /* Ensure ordered list numbers */
                          }
                          li {
                            margin-bottom: 5px;
                          }
                        `}
                </style>

                {/* <div
                  dangerouslySetInnerHTML={{ __html: questionData }}
                  style={{
                    // Reset styles for lists
                    ul: { paddingLeft: "20px", listStyleType: "disc" },
                    ol: { paddingLeft: "20px", listStyleType: "decimal" },
                    li: { marginBottom: "5px" },
                  }}
                />
              </div> */}
                <CKEditor
                  editor={ClassicEditor}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    console.log({ event, editor, data }); // Logs the editor data in the console
                    // onChange={handleInputChange}
                    handleInputChangeQuestion(data, "question");
                  }}
                  data={formData?.question}
                  config={{
                    licenseKey: "GPL", // Use the GPL license.
                    plugins: [
                      Essentials,
                      Paragraph,
                      Bold,
                      Italic,
                      Heading,
                      Link,
                      List,
                      BlockQuote,
                      Image,
                      // Table,
                      MediaEmbed,
                      PasteFromOffice,
                      Font,
                      Alignment,
                    ],
                    toolbar: [
                      "heading",
                      "|",
                      "bold",
                      "italic",
                      "link",
                      "|",
                      "bulletedList",
                      "numberedList",
                      "|",
                      "blockQuote",
                      "insertTable",
                      "|",
                      "undo",
                      "redo",
                      "|",
                      "alignment:left",
                      "alignment:center",
                      "alignment:right",
                      "alignment:justify",
                      "|",
                      "fontColor",
                      "fontBackgroundColor",
                      "fontSize",
                      "|",
                      // "mediaEmbed",
                    ],
                  }}
                />
                {errors.question && (
                  <p className="text-red-500 text-sm mt-1">{errors.question}</p>
                )}
              </div>
            </div>

            {/* Answer Field */}
            <div>
              <label className="block text-sm font-medium mb-1">Answer</label>
              {/* <textarea
                name="answer"
                value={formData.answer}
                onChange={handleInputChange}
                placeholder="Type your reason here"
                className={`w-full p-2 border rounded-md min-h-[100px] resize-none ${
                  errors.answer ? "border-red-500" : ""
                }`}
              /> */}
              <div
                style={{
                  // border: "1px solid #ccc",
                  padding: "10px",
                  marginTop: "10px",
                  lineHeight: "1.6",
                }}
              >
                <style>
                  {`
                          ul, ol {
                            margin: 0;
                            padding-left: 20px;
                            list-style: disc; /* Ensure bullet points */
                          }
                          ol {
                            list-style: decimal; /* Ensure ordered list numbers */
                          }
                          li {
                            margin-bottom: 5px;
                          }
                        `}
                </style>

                {/* <div
                  dangerouslySetInnerHTML={{ __html: questionData }}
                  style={{
                    // Reset styles for lists
                    ul: { paddingLeft: "20px", listStyleType: "disc" },
                    ol: { paddingLeft: "20px", listStyleType: "decimal" },
                    li: { marginBottom: "5px" },
                  }}
                />
              </div> */}
                <CKEditor
                  editor={ClassicEditor}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    console.log({ event, editor, data }); // Logs the editor data in the console
                    handleInputChangeQuestion(data, "answer");
                  }}
                  data={formData?.answer}
                  config={{
                    licenseKey: "GPL", // Use the GPL license.
                    plugins: [
                      Essentials,
                      Paragraph,
                      Bold,
                      Italic,
                      Heading,
                      Link,
                      List,
                      BlockQuote,
                      Image,
                      // Table,
                      MediaEmbed,
                      PasteFromOffice,
                      Font,
                      Alignment,
                    ],
                    toolbar: [
                      "heading",
                      "|",
                      "bold",
                      "italic",
                      "link",
                      "|",
                      "bulletedList",
                      "numberedList",
                      "|",
                      "blockQuote",
                      "insertTable",
                      "|",
                      "undo",
                      "redo",
                      "|",
                      "alignment:left",
                      "alignment:center",
                      "alignment:right",
                      "alignment:justify",
                      "|",
                      "fontColor",
                      "fontBackgroundColor",
                      "fontSize",
                      "|",
                      // "mediaEmbed",
                    ],
                  }}
                />
              </div>

              <div className="flex justify-between text-sm">
                {errors.answer && (
                  <p className="text-red-500">{errors.answer}</p>
                )}
                {/* <span
                  className={`text-right ${
                    formData.answer.length > 500
                      ? "text-red-500"
                      : "text-gray-500"
                  }`}
                >
                  {formData.answer.length}/500
                </span> */}
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex gap-4 mt-6">
            <button
              onClick={onClose}
              className="flex-1 py-2 px-4 border rounded-md text-blue-600 hover:bg-gray-50"
            >
              Cancel
            </button>
            <button
              onClick={handleSubmit}
              className="flex-1 py-2 px-4 rounded-md bg-blue-600 text-white hover:bg-blue-700"
            >
              {editData ? "Update" : "Add"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddFAQModal;
